/**
 * @param state
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright Copyright (c) 2021, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { streamReducer } from './reducers/index'

export const stream = filterActions(streamReducer, Object.values(constants))
